/* unplugin-vue-components disabled */import { render } from "./builder-segment.vue?vue&type=template&id=1005282d&scoped=true"
import script from "./builder-segment.vue?vue&type=script&lang=js"
export * from "./builder-segment.vue?vue&type=script&lang=js"

import "./builder-segment.vue?vue&type=style&index=0&id=1005282d&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1005282d"],['__file',"src/components/builder/builder-segment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1005282d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1005282d', __exports__)) {
    api.reload('1005282d', __exports__)
  }
  
  module.hot.accept("./builder-segment.vue?vue&type=template&id=1005282d&scoped=true", () => {
    api.rerender('1005282d', render)
  })

}


export default __exports__